import { toast } from "react-toastify";
import { API } from "../utils/apk";

export const handleImageChange = async (e, setImageURL, selectedImage) => {
  const file = e.target.files[0];

  if (!file) {
    setImageURL("");
    return;
  }

  const validImageTypes = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/gif",
    "image/webp",
    "image/tiff",
    "image/bmp",
    "image/svg+xml",
  ];

  if (!validImageTypes.includes(file.type)) {
    toast.error("Invalid file type. Please upload an image.");
    setImageURL("");
    return;
  }

  try {
    selectedImage(URL.createObjectURL(file));

    const formData = new FormData();
    formData.append("image", file);

    const response = await fetch(`${API}/upload-image`, {
      method: "POST",
      body: formData,
    });
    const data = await response.json();

    if (!response.ok || !data.success || !data.filePath) {
      throw new Error(data.message || "Image upload failed");
    }

    const imageUrl = `https://api.surajrestaurant.in/${data.filePath}`;
    setImageURL(imageUrl);
    return imageUrl;
  } catch (error) {
    console.error("Error uploading file:", error);
    toast.error(error.message || "Failed to upload image. Please try again.");
    setImageURL("");
    throw error;
  }
};
